<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Unsuccessful Appointments</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="failedHeaders"
              :items="filteredFailedAppointments"
              item-key="id"
              :search="failedSearch"
              :loading="failedLoading"
              :items-per-page="failedItemsPerPage"
              :page.sync="failedPage"
              :server-items-length="failedTotalItems"
              :footer-props="{
                'items-per-page-options': [10],
                'items-per-page-text': 'Rows per page',
              }"
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Missed Appointments</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="missedHeaders"
              :items="filteredMissedAppointments"
              item-key="id"
              :search="missedSearch"
              :loading="missedLoading"
              :items-per-page="missedItemsPerPage"
              :page.sync="missedPage"
              :server-items-length="missedTotalItems"
              :footer-props="{
                'items-per-page-options': [10],
                'items-per-page-text': 'Rows per page',
                
              }"
            ></v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      failedHeaders: [
        { text: 'Business Name', value: 'business_name' },
        { text: 'Reason They didn\'t buy', value: 'notes' },
        { text: 'Phone Number', value: 'phone_number' },
        { text: 'Date', value: 'date' }
      ],
      missedHeaders: [
        { text: 'Business Name', value: 'business_name' },
        { text: 'Action Taken', value: 'notes' },
        { text: 'Rate', value: 'rate' },
        { text: 'Phone Number', value: 'phone_number' },
        { text: 'Date', value: 'date' }
      ],
      appointments: [], // Initialize as an array
      failedLoading: false,
      missedLoading: false,
      failedSearch: '',
      missedSearch: '',
      failedPage: 1,
      missedPage: 1,
      failedItemsPerPage: 10,
      missedItemsPerPage: 10,
      failedTotalItems: 0,
      missedTotalItems: 0,
    };
  },
  mounted() {
    this.fetchAppointments();
  },
  methods: {
    async fetchAppointments() {
      this.failedLoading = true;
      this.missedLoading = true;
      try {
        const response = await axios.get(`/api/admin/appointment-results/get-employee-appointments/${this.id}`);
        this.appointments = response.data;
        this.updateFilteredAppointments();
      } catch (error) {
        console.error('Error fetching appointments:', error);
      } finally {
        this.failedLoading = false;
        this.missedLoading = false;
      }
    },
    updateFilteredAppointments() {
      const startFailedIndex = (this.failedPage - 1) * this.failedItemsPerPage;
      const endFailedIndex = this.failedPage * this.failedItemsPerPage;
      const failedAppointments = this.appointments.filter(appointment => appointment.type === 'Failed');
      this.failedAppointments = failedAppointments.slice(startFailedIndex, endFailedIndex);
      this.failedTotalItems = failedAppointments.length;

      const startMissedIndex = (this.missedPage - 1) * this.missedItemsPerPage;
      const endMissedIndex = this.missedPage * this.missedItemsPerPage;
      const missedAppointments = this.appointments.filter(appointment => appointment.type === 'Missed');
      this.missedAppointments = missedAppointments.slice(startMissedIndex, endMissedIndex);
      this.missedTotalItems = missedAppointments.length;
    },
  },
  computed: {
    filteredFailedAppointments() {
      return this.appointments
        .filter(appointment => appointment.type === 'Failed')
        .slice((this.failedPage - 1) * this.failedItemsPerPage, this.failedPage * this.failedItemsPerPage);
    },
    filteredMissedAppointments() {
      return this.appointments
        .filter(appointment => appointment.type === 'Missed')
        .slice((this.missedPage - 1) * this.missedItemsPerPage, this.missedPage * this.missedItemsPerPage);
    }
  },
  watch: {
    failedPage() {
      this.updateFilteredAppointments();
    },
    missedPage() {
      this.updateFilteredAppointments();
    },
    failedItemsPerPage() {
      this.updateFilteredAppointments();
    },
    missedItemsPerPage() {
      this.updateFilteredAppointments();
    }
  }
};
</script>

<style scoped>
/* Add your custom styles here */
</style>
